import { Component, OnInit } from '@angular/core';
import { PostDO, AllSizesImageDO } from '../../common/data-objects/PostDO';
import { PostsService } from '../../common/services/posts.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { Utils } from '../../common/utils/Utils';
import { SeoService } from 'src/app/common/services/seo.service';

@Component({
  selector: 'app-blog-post-page',
  templateUrl: './blog-post-page.component.html',
  styleUrls: ['./blog-post-page.component.scss'],
})
export class BlogPostPageComponent implements OnInit {
  post: PostDO;
  isLoading: boolean;
  slug: string;

  constructor(
    private postsService: PostsService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService,

  ) {
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.slug = paramMap.get('slug');
    });
  }

  ngOnInit() {
    this.getData();
  }

  private getData() {
    this.isLoading = true;
    this.postsService.getPostBySlug(this.slug).subscribe((post) => {
      this.post = post;
      const title = `${Utils.removeUnicode(this.post.title.rendered)} - Fun Bible`;
      this.seoService.setTitle(title);
      this.isLoading = false;
      this.seoService.setDescription(this.post.excerpt.rendered);
      this.meta.updateTag({
        property: 'og:url',
        content: `https://funbible.net/blog/${post.slug}`
      });
      this.meta.updateTag({
        property: 'og:image',
        content: this.post.featuredImage
      });
      const dynamicKeywords = this.post.readableTagNames.slice(0, 10);
      const finalKeywords = dynamicKeywords.join();
      this.meta.updateTag({property: 'keywords', content: finalKeywords});

      this.angulartics2.eventTrack.next({
        action: title,
        properties: { category: 'pageView' },
      });
    }, () => {
      this.toastr.error('Acest conținut nu există!');
      this.isLoading = false;
    });
  }
}
